import styled from "styled-components";
import {MobileMenuItemLinkBox} from "./mobile-menu-item-link.box";

export const MobileLanguageMenuItemBox = styled(MobileMenuItemLinkBox)`
    padding-left: 4.4rem;
`